import { useContext } from "react";
import { LanguageContext } from "../../scenes/global/languageContext";
export default function AddMore(props) {
  const { language, handleLanguageChange } = useContext(LanguageContext);
  return (
    <button
      onClick={props.onClick}
      className="h-11 sm:px-5 py-2.5 rounded-3xl justify-start items-center gap-2.5 inline-flex"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 17V7"
          stroke="#FF6633"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M7 12L17 12"
          stroke="#FF6633"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </svg>
      <span className="text-center text-orange-500 text-base font-medium">
        {`${language["add_text"]} ${props.text}`}
      </span>
    </button>
  );
}
